export default function findIndexOnCollection(selectedOption, options) {
  if (!selectedOption) return null;
  if (Array.isArray(selectedOption)) {
    const findIndices = selectedOption
      .map((selectedOption) =>
        options.findIndex((option) => option.value === selectedOption)
      )
      .sort();
    return findIndices.pop();
  } else {
    return options.findIndex((option) => option.value === selectedOption);
  }
}
